import VZFSummary from './VZFSummary'

export default VZFSummary
